import type { HelpFile } from '../../types/help'
import { CardSectionTestIds } from '../../../testids/CardSectionTestIds'

export const cardSectionHelp: HelpFile = {
  texts: {
    [CardSectionTestIds.cardSectionDescription]: null,
  },
}
